import {createSlice} from "@reduxjs/toolkit";

const payeeSlice = createSlice({
    name: "payeeRedux",
    initialState: {
        payees: []
    },
    reducers: {
        addPayee: (state, action) => {
            state.payees.push(action.payload);
        },

        editPayee: (state, action) => {
            const updatedPayee = action.payload;
            for(const item of state.payees){
                if(item.payeeId === updatedPayee.payeeId){
                    item.payeeName = updatedPayee.payeeName;
                    item.payeeDesc = updatedPayee.payeeDesc;
                    item.payeeOwner = updatedPayee.payeeOwner;
                    item.payeeBank = updatedPayee.payeeBank;
                    item.payeeAcct = updatedPayee.payeeAcct;
                    item.payeeBankId = updatedPayee.payeeBankId;
                    break;
                }
            }
           
        },
        
    }
});

export const {addPayee, editPayee} = payeeSlice.actions;
export default payeeSlice.reducer;